if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return function () {
      const ctx = this;
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }
}
/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    onSubmitHandler() {
      this.classList.add('loading');

      const rootUrl = theme.routes.root_url === '/' ? '' : theme.routes.root_url;
      const clearUrl = theme.routes.cart_clear_url ? `${theme.routes.cart_clear_url}.js` : `${rootUrl}/cart/clear.js`.replace('//', '/');

      const notesEl = document.getElementById('mini-cart__notes');
      const notesVal = notesEl ? notesEl.value : '';

      fetch(clearUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': notesVal
        })
      }).then(() => {
        this.classList.remove('loading');
        this.drawer.refresh();
      });
    }
  }
  customElements.define('remove-all', RemoveAll);
}